import image from 'assets/images/users/aaLogo.png';
import bgImage from 'assets/images/users/bgImage.png';
import landingPageLeftImage from 'assets/images/users/landingPageLeftImg.png';
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { Eye, EyeOff, Mail, Lock, Loader2 } from 'lucide-react';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { motion } from 'framer-motion';
import { baseURLFinanceVendor } from 'config/apiConfig';
import axios from 'axios';

const ROLE_ROUTE_MAP = {
  Business_Gadget: '/dashboard',
  Admin_Gadget: '/dashboard',
  Dealer_Gadget: '/dashboard',
  Network_Gadget: '/All-registered-cases',
  Agent_Gadget: '/Initiate-Claim',
  Finance_Gadget: '/finance_dashboard',
};

const Login = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [forgetPassword, setForgetPassword] = useState(false);
  const navigate = useNavigate();

  const toggleForm = () => setForgetPassword(!forgetPassword);

  useEffect(() => {
    document.title = 'MCRM Portal Login | Across Assist';
  }, []);


  const fetchData = async () => {
    try {
      const token = localStorage.getItem("token");

      const { data } = await axios.get(
        `${baseURLFinanceVendor}GetOperationsList`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const allUsers =
        data?.operationsUser?.flatMap((group) => group.list || []) || [];

      const emails = allUsers
        .filter(
          (item) =>
            item.type === "Internal" &&
            item.userType === "Gadget"
        )
        .map((item) => item.email);

      localStorage.setItem(
        "internalGadgetEmails",
        JSON.stringify(emails)
      );
    } catch (error) {
      console.error("Error fetching operations data:", error);
    }
  };

  const handleLogin = async (values, setStatus, setSubmitting, setErrors) => {
    try {
      const { email, password } = values;

      const response = await axios.post(`${baseURLFinanceVendor}CRMLogin`, {
        email,
        password,
      });

      const data = response.data;

      if (data?.message !== 'LoginIn Successfully') {
        toast.info(
          'Login failed. Please check your email and password and try again.',
          { autoClose: 2000, theme: 'colored' }
        );
        setSubmitting(false);
        return;
      }

      localStorage.setItem('name', data.name);
      localStorage.setItem('token', data.token);
      localStorage.setItem('refreshToken', data.refreshToken);
      localStorage.setItem('ROLE', data.role);
      localStorage.setItem('email', email);
      localStorage.setItem('userType', data.userType);
      localStorage.setItem('dealer', data.dealer);
      localStorage.setItem('vendor', data.vendor);
      localStorage.setItem('userPermission', JSON.stringify(data.userPermissions));

      await fetchData();

      toast.success(`🎉 Welcome back, ${email}!`, {
        autoClose: 2000,
        theme: 'colored',
      });

      const routeKey = `${data.role}_${data.userType}`;
      const path = ROLE_ROUTE_MAP[routeKey];

      console.log("path", path)

      if (path) {
        setTimeout(() => navigate(path), 1000);
      }
      setSubmitting(false);

    } catch (error) {
      setErrors({
        submit: !navigator.onLine
          ? '🚫 No internet connection. Please check your network.'
          : error?.response?.data?.message ||
          error.message ||
          'Something went wrong. Please try again.',
      });

      setStatus({ success: false });
      setSubmitting(false);
    } finally {
      // setTimeout(() => {
      //   window.location.reload();

      // }, 1000)
    }
  };

  return (
    <div className="min-h-screen flex">
      <ToastContainer />

      <div
        className="hidden md:flex w-1/2 bg-cover bg-center"
        style={{ backgroundImage: `url(${landingPageLeftImage})` }}
      >
        <div className="relative w-full h-full bg-black/30 flex items-center justify-center">
          <h1 className="absolute top-[4vh] text-2xl sm:text-3xl md:text-4xl font-bold text-center bg-gradient-to-r from-indigo-500 via-fuchsia-500 to-orange-400 bg-clip-text text-transparent">
            Across Assist MCRM Portal !!
          </h1>
        </div>
      </div>

      <div
        className="flex w-full md:w-1/2 items-center justify-center px-3 py-3 md:px-6 md:py-8 bg-cover bg-center"
        style={{ backgroundImage: `url(${bgImage})` }}
      >
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: 'easeOut' }}
          className="bg-white/90 backdrop-blur-xl shadow-2xl rounded-xl p-6 w-full max-w-md border"
        >
          <div className="flex flex-col items-center gap-2 mb-4">
            <img src={image} alt="logo" className="w-32" />
            <h2
              className="text-sm sm:text-base md:text-lg lg:text-2xl font-bold text-center
                bg-gradient-to-r from-blue-600 via-purple-600 to-pink-600
                bg-clip-text text-transparent tracking-wide"
            >Welcome Back To MCRM !!</h2>
          </div>

          <Formik
            initialValues={{ email: '', password: '', submit: null }}
            validationSchema={Yup.object().shape({
              email: Yup.string()
                .trim()
                .matches(
                  /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                  'Enter a valid email address'
                )
                .required('Email is required'),
              password: Yup.string().required('Password is required'),
            })}
            onSubmit={(values, helpers) =>
              handleLogin(values, helpers.setStatus, helpers.setSubmitting, helpers.setErrors)
            }
          >
            {({
              errors,
              handleBlur,
              handleChange,
              handleSubmit,
              touched,
              values,
              isSubmitting,
            }) => (
              <form noValidate onSubmit={handleSubmit} className="space-y-4">
                {!forgetPassword ? (
                  <>
                    <div>
                      <label className="block text-sm font-medium mb-1">Email</label>
                      <div className="relative">
                        <Mail className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={16} />
                        <input
                          id="email"
                          type="email"
                          name="email"
                          value={values.email}
                          onBlur={handleBlur}
                          onChange={(e) => {
                            e.target.value = e.target.value.toLowerCase();
                            handleChange(e);
                          }}
                          placeholder="Enter email address"
                          className={`w-full pl-9 pr-3 py-2 rounded-md border ${touched.email && errors.email ? 'border-red-500' : 'border-gray-300'
                            }`}
                        />
                      </div>
                      {touched.email && errors.email && (
                        <p className="text-red-500 text-xs mt-1">{errors.email}</p>
                      )}
                    </div>

                    <div>
                      <label className="block text-sm font-medium mb-1">Password</label>
                      <div className="relative">
                        <Lock className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={16} />
                        <input
                          id="password"
                          type={showPassword ? 'text' : 'password'}
                          name="password"
                          value={values.password}
                          onBlur={handleBlur}
                          onChange={handleChange}
                          placeholder="Enter password"
                          className={`w-full pl-9 pr-9 py-2 rounded-md border ${touched.password && errors.password ? 'border-red-500' : 'border-gray-300'
                            }`}
                        />
                        <button
                          type="button"
                          className="absolute right-3 top-1/2 -translate-y-1/2"
                          onClick={() => setShowPassword(!showPassword)}
                        >
                          {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                        </button>
                      </div>
                      {touched.password && errors.password && (
                        <p className="text-red-500 text-xs mt-1">
                          Login failed. Please check your email and password and try again.
                        </p>
                      )}
                    </div>

                    <div className="flex justify-end !hidden">
                      <button
                        type="button"
                        onClick={toggleForm}
                        className="text-sm text-blue-600 hover:underline"
                      >
                        Forgot Password?
                      </button>
                    </div>

                    {errors.submit && (
                      <p className="text-red-500 text-sm text-center">{errors.submit}</p>
                    )}

                    <button
                      type="submit"
                      disabled={isSubmitting}
                      className="w-full py-2 bg-gradient-to-r from-blue-600 to-pink-600 text-white rounded-lg flex justify-center gap-2"
                    >
                      {isSubmitting ? (
                        <>
                          <Loader2 className="animate-spin" /> Logging in...
                        </>
                      ) : (
                        'Login'
                      )}
                    </button>
                  </>
                ) : (
                  <>
                    <div className="text-center space-y-2">
                      <h3 className="text-lg font-semibold">Forgot Password</h3>
                      <p className="text-gray-600 text-sm">
                        Enter your registered email to receive the reset password link
                      </p>
                    </div>

                    <div>
                      <label className="block text-sm font-medium mb-1">Email</label>
                      <div className="relative">
                        <Mail className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={16} />
                        <input
                          type="email"
                          name="email"
                          value={values.email}
                          onBlur={handleBlur}
                          onChange={handleChange}
                          placeholder="Enter email address"
                          className="w-full pl-9 pr-3 py-2 rounded-md border border-gray-300"
                        />
                      </div>
                    </div>

                    <button
                      type="submit"
                      disabled={isSubmitting}
                      className="w-full py-2 bg-gradient-to-r from-blue-600 to-pink-600 text-white rounded-lg"
                    >
                      {isSubmitting ? 'Sending...' : 'Send Reset Password Link'}
                    </button>
                  </>
                )}
              </form>
            )}
          </Formik>

          <p className="mt-6 text-xs text-gray-500 text-center leading-relaxed">
            By signing in, you agree to our{' '}
            <span className="text-blue-600 cursor-pointer">Terms of Service</span> and{' '}
            <span className="text-blue-600 cursor-pointer">Privacy Policy</span>.
            <br />© 2024 Across Assist. All rights reserved.
          </p>
        </motion.div>
      </div>
    </div>
  );
};

export default Login;
